import { useState } from 'react'

/** A password input with a Show/Hide toggle. Takes the usual input props. */
export function PasswordInput(props: Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>) {
  const [shown, setShown] = useState(false)
  return (
    <div className="pw">
      {/* Spellcheck off so a revealed password is not sent to a spelling service. */}
      <input {...props} type={shown ? 'text' : 'password'} spellCheck={false} autoCapitalize="off" autoCorrect="off" />
      <button
        type="button"
        className="pw-toggle"
        onClick={() => setShown((s) => !s)}
        aria-pressed={shown}
        aria-controls={props.id}
        aria-label={shown ? 'Hide password' : 'Show password'}
      >
        {shown ? 'Hide' : 'Show'}
      </button>
    </div>
  )
}
